import React from 'react'
import { Popover } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

export const IdleTimeoutLabel = () => (
    <span>
        Idle Timeout
        <Popover
            content="How long a user can be inactive before their session expires. Accepts values from 2 minutes to 12 hours."
        >
            <InfoCircleOutlined className="info-icon" />
        </Popover>
    </span>
)

export const AbsoluteTimeoutLabel = () => (
    <span>
        Absolute Timeout
        <Popover
            content="The maximum length of a session regardless of activity. Accepts values from 2 minutes to 12 hours, and must be greater than or equal to the idle timeout."
        >
            <InfoCircleOutlined className="info-icon" />
        </Popover>
    </span>
)
